
const topic_array = [
    '少壮不努力#何时复西归#老大徒伤悲#缘愁似个长#当春乃发生#2',
    '少小离家老大回#笑问客从何处来#二月春风似剪刀#乡音无改鬓毛衰#门泊东吴万里船#3',
    '此曲只应天上有#天上能得几回闻#人间哪得几回闻#落花时节又逢君#人间能得几回闻#4',
    '正是江南好风景#落花时节又逢君#长使英雄泪满襟#莫使金樽空对月#无人知是荔枝来#1',
    '好雨知时节#当春乃发生#把酒问青天#一览众山小#长河落日圆#1',
    '随风潜入夜#润物俱无声#湿物细无声#润物细无声#大雪满弓刀#3',
    '柴门闻犬吠#风雨夜归人#风雨夜回人#风雪夜回人#风雪夜归人#4',
    '千山鸟飞绝#万径人踪灭#独钓寒江雪#可怜无数山#只是近黄昏#1',
    '孤舟蓑笠翁#独钓寒江雪#垂钓寒江雪#垂钓松江雪#独钓松江雪#1',
    '月落乌啼霜满天#夜半钟声到客船#江枫渔火对愁眠#春来江水绿如蓝#明月何时照我还#2',
    '西塞山前白鹭飞#梨花流水鳜鱼肥#桃花流水桂鱼肥#桃花流水鳜鱼肥#梨花流水桂鱼肥#3',
    '欲将轻骑逐#月涌大江流#大雪满弓刀#月是故乡明#清泉石上流#2',
    '慈母手中线#游子身上衣#临行密密缝#意恐迟迟归#报得三春晖#1',
    '东边日出西边雨#二月春风似剪刀#道是无晴却有晴#春风不度玉门关#万里长征人未还#2',
    '旧时王谢堂前燕#飞入平常百姓家#飞到寻常百姓家#飞到平常百姓家#飞入寻常百姓家#4',
    '日出江花红胜火#春来江水绿如蓝#明月何时照我还#夜半钟声到客船#江枫渔火对愁眠#1',
    '谁知盘中餐#颗颗皆辛苦#粒粒都辛苦#粒粒皆辛苦#颗颗都辛苦#3',
    '远上寒山石径斜#乌云生处有人家#白云生处有人家#彩云生处有人家#青云生处有人家#2',
    '停车坐爱枫林晚#枫叶红于二月花#霜叶红于五月花#枫叶红于五月花#霜叶红于二月花#4',
    '借问酒家何处有#多少楼台烟雨中#牧童遥指杏花村#总把新桃换旧符#明月何时照我还#2',
    '南朝四百八十寺#多少楼台烟雨中#多少楼阁烟雨中#多少楼台雾雨中#多少楼阁雾雨中#1',
    '夕阳无限好#已是近黄昏#只是到黄昏#只是近黄昏#已是到黄昏#3',
    '千门万户曈曈日#多少楼台烟雨中#万里长征人未还#牧童遥指杏花村#总把新桃换旧符#4',
    '春风又绿江南岸#明月何时照我还#夜半钟声到客船#江枫渔火对愁眠#春来江水绿如蓝#1',
    '欲把西湖比西子#浓抹淡妆总相宜#淡妆浓抹总相宜#淡妆浓抹皆相宜#浓抹淡妆皆相宜#2',
    '竹外桃花三两枝#正是河豚欲上时#在地愿为连理枝#万里长征人未还#春江水暖鸭先知#4',
    '横看成岭侧成峰#远近高低各不同#但悲不见九州同#映日荷花别样红#半江瑟瑟半江红#1',
    '至今思项羽#不愿过江东#不想过江东#不肯过江东#不敢过江东#3',
    '王师北定中原日#家祭无忘告乃翁#但悲不见九州同#死去元知万事空#烈火焚烧若等闲#1',
    '接天莲叶无穷碧#半江瑟瑟半江红#化作春泥更护花#露似珍珠月似弓#映日荷花别样红#4',];

function get_topic_info(topic_id)
{
    var topic = topic_array[topic_id].split("#");
    var topic_info = {
        "topic_title": topic[0],
        "topic_choice": [topic[1],topic[2],topic[3],topic[4]],
        "topic_answer":topic[5],
    }
    return topic_info;
}

export{
    topic_array,
  get_topic_info
}
/*
export default {
    get_topic_info,

  }
*/



// WEBPACK FOOTER //
// ./src/components/common.js